import { Pipe, PipeTransform } from '@angular/core';
import { CategoryProduct, EWishlistStatus } from '@atlas-workspace/shared/models';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'wishlistStatus',
  standalone: true
})
export class WishlistStatusPipe implements PipeTransform {

  constructor(private readonly translate: TranslateService) {}

  transform(product: CategoryProduct): string {
    if (!product) return '';
    
    if (product.status === EWishlistStatus.Completed && product.autoCompleted) {
      return this.translate.instant('Shared.Title.Auto_selected');
    }
    if (
      product.status === EWishlistStatus.Completed &&
      !product.autoCompleted &&
      (product.signingStatus === EWishlistStatus.NotSigned ||
        product.signingStatus === EWishlistStatus.ReadyForSigning) &&
      product.allowBankId
    ) {
      return this.translate.instant('Shared.Title.Not_signed');
    }
    if (
      product.allowBankId &&
      product.status === EWishlistStatus.Completed &&
      product.signingStatus === EWishlistStatus.Signed
    ) {
      return this.translate.instant('Shared.Title.Signed');
    }
    if (product.status === EWishlistStatus.Completed) {
      return this.translate.instant('Shared.Status.Options.Completed');
    }
    if (product.status === EWishlistStatus.NotSelected) {
      return this.translate.instant('Shared.Entity.Not_selected');
    }
    if (product.status === EWishlistStatus.Blocked) {
      return this.translate.instant('Shared.Title.Blocked');
    }
    return this.translate.instant('Shared.Status.Options.In_progress');
  }
}
